module.exports = __webpack_public_path__ + "static/media/delivery-bike.ca71928c.svg";